<template>
  <div class="footerBox">
    <div class="txt">{{$t('footer.titleTop')}}</div>
    <div class="txt">{{$t('footer.title')}}</div>

    <div class="box">
      <div class="p">
        <img src="../../static/address.png" alt="" />
        
        <div class="pTxt">{{$t('footer.address')}}</div>
      </div>

      <div class="p">
        <img src="../../static/phone.png" alt="" />
        <div class="pTxt">010-84293556</div>
      </div>

      <div class="p">
        <img src="../../static/email.png" alt="" />
        <div class="pTxt">chinaminexpo@vip.163.com</div>
      </div>

      <div class="p">
        <img src="../../static/earth.png" alt="" />
        <div class="pTxt">www.chinaminexpo.com</div>
      </div>
    </div>

    <div class="imgBox">
      <img src="../../static/erweiMa.png" alt="" />
      <div class="saoMa">{{$t('footer.mobileQrCodeAttention')}}</div>
    </div>

    <div class="bottom">
      <p>{{$t('footer.copyright')}}</p>
      <p>{{$t('footer.technicalSupport')}}</p>
      <p>{{$t('footer.spareNumber1')}} {{$t('footer.spareNumber2')}}</p>
      <p>{{$t('footer.titleTop')}}Copyright © 2018. All Rights Reserved</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.footerBox {
  width: 100vw;
  padding-top: 15px;
  background-color: #006fb8;
  .txt {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 23px;
    padding:0px 15px;
    box-sizing: border-box;
    padding-top: 5px;
  
  }
  .box {
    padding-top: 20px;
    .p {
      display: flex;
      justify-content: flex-start;
      padding-left: 15px;
      box-sizing: border-box;
      align-items: center;
      padding-top: 16px;
      align-items: flex-start;
      img {
        width: 16px;
        height: 16px;
      }
      .pTxt {
        padding-left: 6px;
        box-sizing: border-box;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 17px;
      }
    }
  }
  .imgBox {
    width: fit-content;
    margin: 0 auto;
    text-align: center;
    padding-top: 40px;
    padding-bottom: 25px;
    img {
      width: 130px;
      height: 130px;
    }
    .saoMa {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      padding-top: 15px;
      padding-left: 30px;
      padding-right: 30px;
      box-sizing: border-box;
    }
  }
  .bottom {
    width: 100%;
    background: #000000;
    opacity: 0.6;
    padding: 25px 25px;
    box-sizing: border-box;
    p {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #a4cdff;
      line-height: 22px;
      text-align: center;
    }
  }
}
</style>
